var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.9 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a28f674a-7dec-48d0-975b-b52e2752fcc1{fill:#154390;}.b50d76f2-e6ef-436b-b816-0c2a7f0d347c{fill:#fff;}.a7251894-d77f-471e-987e-64972745601f{fill:#1d1d1b;}.aa31d124-73ee-4861-b685-8ddfd4ca528d{fill:#676766;}.ec566d64-f21e-4b34-b0d4-64c98db9022b{fill:#e73a3a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a8c974aa-4f49-4581-bd30-756535824a5a",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aaede6ac-ebac-4070-a0f4-69900b4863d2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a28f674a-7dec-48d0-975b-b52e2752fcc1",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b50d76f2-e6ef-436b-b816-0c2a7f0d347c",
    cx: 9,
    cy: 9,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "a7251894-d77f-471e-987e-64972745601f",
    d: "M40.6,16.2V4.5h2.2l5,8.3H46.6l4.9-8.3h2.2V16.2H51.2V8.4h.4l-3.9,6.5H46.5L42.6,8.4h.5v7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a7251894-d77f-471e-987e-64972745601f",
    d: "M61.7,16.4A5.3,5.3,0,0,1,57.8,15a5.3,5.3,0,0,1-1.4-3.9V4.5h2.7V11a3.3,3.3,0,0,0,.7,2.4,2.7,2.7,0,0,0,1.9.7,2.9,2.9,0,0,0,1.9-.7,3.3,3.3,0,0,0,.7-2.4V4.5h2.6v6.6A5.3,5.3,0,0,1,65.6,15,5.6,5.6,0,0,1,61.7,16.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a7251894-d77f-471e-987e-64972745601f",
    d: "M69.6,16.2V4.5h2.7V14h5.9v2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a7251894-d77f-471e-987e-64972745601f",
    d: "M80.8,16.2V6.7H77.1V4.5H87.3V6.7H83.5v9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a7251894-d77f-471e-987e-64972745601f",
    d: "M88.7,16.2V4.5h2.7V16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a7251894-d77f-471e-987e-64972745601f",
    d: "M94.2,16.2V4.5h5.7a5.4,5.4,0,0,1,3.3.9,2.5,2.5,0,0,1,1.1,2.2,2.5,2.5,0,0,1-.5,1.5,3.2,3.2,0,0,1-1.2,1.1,4.8,4.8,0,0,1-1.8.4l.3-.7a6,6,0,0,1,2,.3,3.5,3.5,0,0,1,1.3,1.1,3.1,3.1,0,0,1,.5,1.7,2.6,2.6,0,0,1-1.2,2.3,5.8,5.8,0,0,1-3.5.9Zm2.7-2H100a3.4,3.4,0,0,0,1.6-.4c.4-.2.5-.6.5-1.1a1.2,1.2,0,0,0-.5-1.1,3.5,3.5,0,0,0-1.6-.3H96.7v-2h2.8A2.8,2.8,0,0,0,101,9a1.3,1.3,0,0,0,.6-1.1,1.1,1.1,0,0,0-.6-1,2.8,2.8,0,0,0-1.5-.3H96.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a7251894-d77f-471e-987e-64972745601f",
    d: "M106.9,16.2V4.5h8.8V6.7h-6.1V14h6.3v2.2Zm2.5-4.9V9.2H115v2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa31d124-73ee-4861-b685-8ddfd4ca528d",
    d: "M39.1,30.8l5.2-11.6h2.6l5.2,11.6H49.3L45,20.5h1.1L41.8,30.8Zm2.6-2.5.7-2h6l.7,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa31d124-73ee-4861-b685-8ddfd4ca528d",
    d: "M58.3,31a5.3,5.3,0,0,1-3.9-1.3,5.7,5.7,0,0,1-1.4-4V19.2h2.7v6.4a3.3,3.3,0,0,0,.7,2.4,2.4,2.4,0,0,0,1.9.7,2.5,2.5,0,0,0,1.9-.7,3.3,3.3,0,0,0,.7-2.4V19.2h2.7v6.5a5.7,5.7,0,0,1-1.4,4A5.6,5.6,0,0,1,58.3,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa31d124-73ee-4861-b685-8ddfd4ca528d",
    d: "M68.4,30.8V21.4H64.7V19.2H74.8v2.2H71.1v9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa31d124-73ee-4861-b685-8ddfd4ca528d",
    d: "M81.8,31a7.1,7.1,0,0,1-2.6-.4,5.3,5.3,0,0,1-2-1.3,6.7,6.7,0,0,1-1.4-1.9,6.1,6.1,0,0,1-.4-2.4,6.1,6.1,0,0,1,.4-2.4,6.7,6.7,0,0,1,1.4-1.9,6.9,6.9,0,0,1,2-1.3,7.1,7.1,0,0,1,2.6-.4,5.9,5.9,0,0,1,4.5,1.7,5,5,0,0,1,1.3,1.9,4.7,4.7,0,0,1,.5,2.4,4.7,4.7,0,0,1-.5,2.4,4.3,4.3,0,0,1-1.3,1.9,5.3,5.3,0,0,1-2,1.3A6.9,6.9,0,0,1,81.8,31Zm0-2.3,1.4-.2,1.2-.8a3.5,3.5,0,0,0,.7-1.2,3.3,3.3,0,0,0,.3-1.5,3.7,3.7,0,0,0-.3-1.5,3.5,3.5,0,0,0-.7-1.2l-1.2-.8-1.4-.2-1.5.2-1.1.8a2.5,2.5,0,0,0-.8,1.2,3.7,3.7,0,0,0-.3,1.5,3.3,3.3,0,0,0,.3,1.5,3.5,3.5,0,0,0,.7,1.2l1.2.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ec566d64-f21e-4b34-b0d4-64c98db9022b",
    points: "5 25.8 10.1 30.9 5 30.9 5 25.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ec566d64-f21e-4b34-b0d4-64c98db9022b",
    d: "M28.9,30.9H18.1L8.6,21.4a17.7,17.7,0,0,0,7.3-3.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ec566d64-f21e-4b34-b0d4-64c98db9022b",
    points: "34.5 4.7 34.5 11.6 27.6 4.7 34.5 4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ec566d64-f21e-4b34-b0d4-64c98db9022b",
    d: "M34.5,19.6v8.9L19.6,13.6A18.2,18.2,0,0,0,22,7.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7b8b40d6c7595105ae847195134e9799.svg";
export { ForwardRef as ReactComponent };